import { boatSchema } from "./schema";
import { getDate } from "@poseidon/firebase/timestamp";

export const mapBoat = (snap) => {
  let document = snap.data();
  document = {
    ...document,
    createdAt: getDate(document.createdAt),
    updatedAt: getDate(document.updatedAt),
  };

  const boatData = boatSchema.cast(document);

  return {
    ...boatData,
    id: snap.id,
  };
};

export const mapBoatToBoatUpdateRequest = (boat, isDealer) => {
  let result = boatSchema.cast(boat, { stripUnknown: true });
  if (result && isDealer) {
    delete result.make;
    delete result.model;
    delete result.type;
    delete result.homeMarina;
    delete result.createdAt;
  }
  return result;
};
